const mutations = {
	SET_PUSH_LIST(state, data) {
		state.items = data.content;
		state.totalElements = data.totalElements
		state.totalPages = data.totalPages;
		this.loadingClear = false;
	},
	LOADING_CLEAR(state, value) {
		state.loadingClear = value;
	},
	SET_PUSHLOGS_LIST(state, data) {
		state.totalPages = 0
		state.items = data.requestByUser;
		state.totalElements = data.countPages * state.page_size;
		state.totalPages = data.countPages;
	},
	SET_SEARCH_EMAIL_FILTER(state, data) {
		state.email = data
	},
	SET_REQUEST_URI(state, data) {
		state.requestURI = data
	},
	SET_SEARCH_MESSAGE_FILTER(state, data) {
		state.search_message = data
	},
	SET_CURRENT_PAGE(state, data) {
		state.current_page = data
	},
	SET_SERVICE(state, data) {
		state.services = data
	},
	SET_LOGS_TO_EDIT(state, data) {
		const logsInfo = JSON.parse(JSON.stringify(data))
		state.logsToEdit = {
			...state.logsToEdit,
			...logsInfo
		}
	},
	UNSET_LOGS_TO_EDIT(state, data) {
		state.logsToEdit = {
			channelType: '',
			dateAdded: '',
			list: '',
			message: '',
			messageType: '',
			moeCampaignName: '',
			name: '',
			produtoSlug: null,
			pushType: null,
			requestJson: '',
			responseJson: '',
			sendTime: null,
			smsContent: '',
			title: '',
			url: null,
		}
	},
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/push_web/mutations.js